import { Component, Input, ViewEncapsulation } from '@angular/core';
import { IconMapper } from '../../helpers/icon-mapper';

@Component({
       selector: 'cfa-app-brand-button',
    templateUrl: './app-brand-button.html',
    styleUrls: ['../../../styles/styles.scss', './app-brand-button.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CfaAppBrandButton extends IconMapper {

    @Input() appName: string;

    icon = 'CFA';

    constructor() {
        super();
    }

}
